/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-20 15:42:12
 * @LastEditTime : 2020-01-13 16:20:33
 * @LastEditors  : Please set LastEditors
 */
// import { ESVStorage } from 'esvcp-mobile';
import login from '@/pages/login'; // 登录
// import pdfBrowse from '@/pages/pdfBrowse'; // pdf预览页面
import tarbarPage from '@/pages/tarbarPage'; // 有底部tab
import homenew from '@/pages/homenew'; // 首页
import platform from '@/pages/platform'; // 分类
import shoppingcart from '@/pages/shoppingcart'; // 购物车
import shoppingcartBottomNone from '@/pages/shoppingcartBottomNone'; // 购物车2
import membercenter from '@/pages/membercenter'; // 会员中心
import confirmOrder from '@/pages/confirmOrder'; // 确认订单
import payorder from '@/pages/payorder'; // 支付订单
import goodsdetail from '@/pages/goodsdetail'; // 商品详情
import groupDetail from '@/pages/groupDetail'; // 套装商品详情
import groupList from '@/pages/groupList'; // 套装商品列表
import activityPage from '@/pages/activityPage'; // 自定义活动
import goodlist from '@/pages/goodlist'; // 商品列表
import paysuccess from '@/pages/paysuccess'; // 支付成功
import payfail from '@/pages/payfail'; // 支付失败
import evaluation from '@/pages/evaluation'; // 评价
import personalInformation from '@/pages/personalInformation'; // 个人信息修改
import coupon from '@/pages/coupon'; // 红包卡券
import myOrder from '@/pages/myOrder'; // 我的订单
import addressManage from '@/pages/addressManage'; // 地址管理
import addAddress from '@/pages/addAddress'; // 新增地址
import couponsRules from '@/pages/couponsRules'; // 优惠券规则
import networkAnomaly from '@/pages/networkAnomaly'; // 网络异常
import pageAnomaly from '@/pages/pageAnomaly'; // 鉴权异常
import exchangeCoupon from '@/pages/exchangeCoupon'; // 优惠券兑换
import choiceAfterSalesService from '@/pages/choiceAfterSalesService'; // 优惠券兑换
import afterSalesDetails from '@/pages/afterSalesDetails'; // 优惠券兑换
import applyAfterSales from '@/pages/applyAfterSales'; // 售后申请
import afterSalesList from '@/pages/afterSalesList'; // 售后列表
import notFound404 from '@/pages/notFound404'; // 404页面
// 收藏夹
import collectionList from '@/pages/collectionList';
// 发表评价
import evaluate from '@/pages/evaluate';
// 订单详情
import orderDetails from '@/pages/orderDetails';
// 交易成功
import deliverySuccess from '@/pages/deliverySuccess';
// 评论成功
import commentSuccess from '@/pages/commentSuccess';
// 退款
import refund from '@/pages/refund';
// 添加和编辑
import choiceGood from '@/pages/choiceGood';
// 选择退货服务类型
import choiceRefundType from '@/pages/choiceRefundType';
// 选择地址
import choiceAddress from '@/pages/choiceAddress';
// 退货/售后页面
import returnGoodsList from '@/pages/returnGoodsList';
// 详情页面
import returnGoodsDetails from '@/pages/returnGoodsDetails';
// 发票管理
import invoiceList from '@/pages/invoiceList';
// 发票详情
import invoiceDetails from '@/pages/invoiceDetails';
// 发票发送
import sendInvoiceEmail from '@/pages/sendInvoiceEmail';
// 满减活动
import fullActivitys from '@/pages/fullActivitys';
// 积分
import integral from '@/pages/integral';
// 积分
import logisticsList from '@/pages/logisticsList';
// 查看无效购物券
import seeVoucher from '@/pages/seeVoucher';
// 点击领取优惠券外部页面
import receiveCoupon from '@/pages/receiveCoupon';
// 点击领取优惠券外部页面
import blankTo from '@/pages/blankTo';
import invoice from '@/pages/invoice';
// 搜索页
import search from '@/pages/search';
// 标签列表
import tagList from '@/pages/tagList';
import dotManage from '@/pages/dotManage'; // 网点
import choiceDot from '@/pages/choiceDot'; // 网点选择
import publicityPage from '@/pages/publicityPage'; // 宣传页
import openDistribution from '@/pages/openDistribution'; // 分销开通表单
import distributionPage from '@/pages/distributionPage'; // 我的分销
import openSuccess from '@/pages/openSuccess'; // 分销开通成功
import withdrawDetails from '@/pages/withdrawDetails'; // 提现详情
import withdrawalRequest from '@/pages/withdrawalRequest'; // 申请提现
import choiceCompany from '@/pages/choiceCompany'; // 申请提现
import sysMaintenance from '@/pages/sysMaintenance'; // 系统维护中
import middleLogin from '@/pages/middlelogin';// 中间跳转页

// OWCModule
import OWCModule from '@/base/module';
const routes = [{
    path: '*',
    redirect: 'OPHomenew',
    component: tarbarPage,
    children: [{
        name: 'OPHomenew',
        path: '/opHomenew',
        component: homenew,
        meta: {
            requireAuth: false,
            tabBarIndex: 0,
            title: '',
            isTabbarPage: true
        }
    }, {
        name: 'OPGoodlist',
        path: '/opGoodlist',
        component: goodlist,
        meta: {
            requireAuth: false,
            tabBarIndex: 1,
            isTabbarPage: true,
            title: '商品列表'
        }
    }, {
        name: 'OPDotManage',
        path: '/opDotManage',
        component: dotManage,
        meta: {
            requireAuth: false,
            tabBarIndex: 2,
            title: '网点'
        }
    }, {
        name: 'OPMembercenter',
        path: '/opMembercenter',
        component: membercenter,
        meta: {
            requireAuth: false,
            tabBarIndex: 4,
            title: '会员中心'
        }
    }, {
        name: 'OPShoppingcart',
        path: '/opShoppingcart',
        component: shoppingcart,
        meta: {
            requireAuth: false,
            tabBarIndex: 3,
            title: '购物车'
        }
    }]
}];

const nonTarbarRouter = [{
    name: 'OPLogin',
    component: login,
    path: '/opLogin',
    meta: {
        title: '登录页面'
    }
}, {
    name: 'OPPlatform',
    path: '/opPlatform',
    component: platform,
    meta: {
        requireAuth: false,
        title: '商品分类'
    }
// }, {
//     name: 'OPPdfBrowse',
//     path: '/opPdfBrowse',
//     component: pdfBrowse,
//     meta: {
//         title: 'pdf'
//     }
}, {
    name: 'OPGoodsdetail',
    path: '/opGoodsdetail',
    component: goodsdetail,
    meta: {
        requireAuth: false,
        title: '商品详情'
    }
}, {
    name: 'OPChoiceDot',
    path: '/opChoiceDot',
    component: choiceDot,
    meta: {
        requireAuth: false,
        title: '网点选择'
    }
}, {
    name: 'OPGroupDetail',
    path: '/opGroupDetail',
    component: groupDetail,
    meta: {
        requireAuth: false,
        title: '套装详情'
    }
}, {
    name: 'OPGroupList',
    path: '/opGroupList',
    component: groupList,
    meta: {
        requireAuth: false,
        title: '优惠套装'
    }
}, {
    name: 'OPActivityPage',
    path: '/opActivityPage',
    component: activityPage,
    meta: {
        requireAuth: false,
        title: '活动'
    }
}, {
    name: 'OPWithdrawDetails',
    path: '/opWithdrawDetails',
    component: withdrawDetails,
    meta: {
        requireAuth: false,
        title: '分销提现'
    }
}, {
    name: 'OPWithdrawalRequest',
    path: '/opWithdrawalRequest',
    component: withdrawalRequest,
    meta: {
        requireAuth: false,
        title: '分销提现'
    }
}, {
    name: 'OPConfirmOrder',
    path: '/opConfirmOrder',
    component: confirmOrder,
    meta: {
        requireAuth: false,
        title: '确认订单'
    }
}, {
    name: 'OPPayorder',
    path: '/opPayorder',
    component: payorder,
    meta: {
        requireAuth: false,
        title: '支付订单'
    }
}, {
    name: 'OPPublicityPage',
    path: '/opPublicityPage',
    component: publicityPage,
    meta: {
        requireAuth: false,
        title: '分享'
    }
}, {
    name: 'OPOpenDistribution',
    path: '/opOpenDistribution',
    component: openDistribution,
    meta: {
        requireAuth: false,
        title: '开通账户'
    }
}, {
    name: 'OPOpenSuccess',
    path: '/opOpenSuccess',
    component: openSuccess,
    meta: {
        requireAuth: false,
        title: '开通成功'
    }
}, {
    name: 'OPDistributionPage',
    path: '/opDistributionPage',
    component: distributionPage,
    meta: {
        requireAuth: false,
        title: '我的分销'
    }
}, {
    name: 'OPInvoiceList',
    path: '/opInvoiceList',
    component: invoiceList,
    meta: {
        requireAuth: false,
        title: '发票管理'
    }
}, {
    name: 'OPInvoiceDetails',
    path: '/opInvoiceDetails',
    component: invoiceDetails,
    meta: {
        requireAuth: false,
        title: '发票详情'
    }
}, {
    name: 'OPSendInvoiceEmail',
    path: '/opSendInvoiceEmail',
    component: sendInvoiceEmail,
    meta: {
        requireAuth: false,
        title: '发票发送'
    }
}, {
    name: 'OPPaysuccess',
    path: '/opPaysuccess',
    component: paysuccess,
    meta: {
        requireAuth: false,
        title: '支付成功'
    }
}, {
    name: 'OPPayfail',
    path: '/opPayfail',
    component: payfail,
    meta: {
        requireAuth: false,
        title: '支付失败'
    }
}, {
    name: 'OPEvaluation',
    component: evaluation,
    path: '/opEvaluation',
    meta: {
        title: '评价'
    }
}, {
    name: 'OPPersonalInformation',
    component: personalInformation,
    path: '/opPersonalInformation',
    meta: {
        title: '个人信息修改'
    }
}, {
    name: 'OPCoupon',
    component: coupon,
    path: '/opCoupon',
    meta: {
        title: '红包卡券'
    }
}, {
    name: 'OPMyOrder',
    component: myOrder,
    path: '/opMyOrder',
    meta: {
        title: '我的订单'
    }
}, {
    name: 'OPAddressManage',
    component: addressManage,
    path: '/opAddressManage',
    meta: {
        title: '地址管理'
    }
}, {
    name: 'OPCollectionList',
    component: collectionList,
    path: '/opCollectionList',
    meta: {
        title: '收藏夹'
    }
}, {
    name: 'OPEvaluate',
    component: evaluate,
    path: '/opEvaluate',
    meta: {
        title: '评价'
    }
}, {
    name: 'OPOrderDetails',
    component: orderDetails,
    path: '/opOrderDetails',
    meta: {
        title: '订单详情'
    }
}, {
    name: 'OPDeliverySuccess',
    component: deliverySuccess,
    path: '/opDeliverySuccess',
    meta: {
        title: '交易成功'
    }
}, {
    name: 'OPCommentSuccess',
    component: commentSuccess,
    path: '/opCommentSuccess',
    meta: {
        title: '评论成功'
    }
}, {
    name: 'OPRefund',
    component: refund,
    path: '/opRefund',
    meta: {
        title: '退款'
    }
}, {
    name: 'OPChoiceGood',
    component: choiceGood,
    path: '/opChoiceGood',
    meta: {
        title: '添加和编辑'
    }
}, {
    name: 'OPChoiceRefundType',
    component: choiceRefundType,
    path: '/opChoiceRefundType',
    meta: {
        title: '选择服务类型'
    }
}, {
    name: 'OPAddAddress',
    component: addAddress,
    path: '/opAddAddress',
    meta: {
        title: '新增收货地址'
    }
}, {
    name: 'OPChoiceAddress',
    component: choiceAddress,
    path: '/opChoiceAddress',
    meta: {
        title: '选择收货地址'
    }
}, {
    name: 'OPReturnGoodsList',
    component: returnGoodsList,
    path: '/opReturnGoodsList',
    meta: {
        title: '退货/售后列表'
    }
}, {
    name: 'OPReturnGoodsDetails',
    component: returnGoodsDetails,
    path: '/opReturnGoodsDetails',
    meta: {
        title: '退货详情'
    }
}, {
    name: 'OPShoppingcartBottomNone',
    path: '/opShoppingcartBottomNone',
    component: shoppingcartBottomNone,
    meta: {
        requireAuth: false,
        title: '购物车'
    }
}, {
    name: 'OPCouponsRules',
    component: couponsRules,
    path: '/opCouponsRules',
    meta: {
        title: '优惠券规则'
    }
}, {
    name: 'OPLogisticsList',
    component: logisticsList,
    path: '/opLogisticsList',
    meta: {
        title: '查看物流列表'
    }
}, {
    name: 'OPFullActivitys',
    component: fullActivitys,
    path: '/opFullActivitys',
    meta: {
        title: '满减活动'
    }
}, {
    name: 'OPNetworkAnomaly',
    component: networkAnomaly,
    path: '/opNetworkAnomaly',
    meta: {
        title: '网络异常'
    }
}, {
    name: 'OPPageAnomaly',
    component: pageAnomaly,
    path: '/opPageAnomaly',
    meta: {
        title: '鉴权异常'
    }
}, {
    name: 'OPIntegral',
    component: integral,
    path: '/opIntegral',
    meta: {
        title: '积分'
    }
}, {
    name: 'OPSeeVoucher',
    component: seeVoucher,
    path: '/opSeeVoucher',
    meta: {
        title: '查看无效券'
    }
}, {
    name: 'OPReceiveCoupon',
    component: receiveCoupon,
    path: '/opReceiveCoupon',
    meta: {
        title: '领取优惠券'
    }
}, {
    name: 'OPBlankTo',
    component: blankTo,
    path: '/opBlankTo',
    meta: {
        title: ''
    }
}, {
    name: 'OPExchangeCoupon',
    component: exchangeCoupon,
    path: '/opExchangeCoupon',
    meta: {
        title: '优惠劵兑换'
    }
}, {
    name: 'OPChoiceAfterSalesService',
    component: choiceAfterSalesService,
    path: '/opChoiceAfterSalesService',
    meta: {
        title: '售后'
    }
}, {
    name: 'OPAfterSalesDetails',
    component: afterSalesDetails,
    path: '/opAfterSalesDetails',
    meta: {
        title: '售后详情'
    }
}, {
    name: 'OPApplyAfterSales',
    component: applyAfterSales,
    path: '/opApplyAfterSales',
    meta: {
        title: '售后申请'
    }
}, {
    name: 'OPAfterSalesList',
    component: afterSalesList,
    path: '/opAfterSalesList',
    meta: {
        title: '售后列表'
    }
}, {
    name: 'OPInvoice',
    component: invoice,
    path: '/opInvoice',
    meta: {
        title: '开具发票'
    }
}, {
    name: 'OPSearch',
    component: search,
    path: '/opSearch',
    meta: {
        title: '搜索'
    }
}, {
    name: 'OPNotFound',
    component: notFound404,
    path: '/opNotFound',
    meta: {
        title: '找不到页面'
    }
}, {
    name: 'OPTagList',
    component: tagList,
    path: '/opTagList',
    meta: {
        title: '商品列表'
    }
}, {
    name: 'OPChoiceCompany',
    component: choiceCompany,
    path: '/opChoiceCompany',
    meta: {
        title: '选择公司'
    }
}, {
    name: 'OPSysMaintenance',
    component: sysMaintenance,
    path: '/opSysMaintenance',
    meta: {
        title: '系统维护'
    }
}, {
    name: 'OPMiddleLogin',
    component: middleLogin,
    path: '/OPMiddleLogin',
    meta: {
        title: '登录'
    }
}];

routes.forEach(r => {
    if (r.meta !== undefined) {
        r.meta.module = OWCModule.Common;
    } else if (r.children !== undefined) {
        r.children.forEach(c => {
            if (c.meta !== undefined) {
                c.meta.module = OWCModule.Common;
            }
        });
    }
});

nonTarbarRouter.forEach(r => {
    if (r.meta !== undefined) {
        r.meta.module = OWCModule.Common;
    } else if (r.children !== undefined) {
        r.children.forEach(c => {
            if (c.meta !== undefined) {
                c.meta.module = OWCModule.Common;
            }
        });
    }
});

export default [
    ...routes,
    ...nonTarbarRouter
];
